/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `ORIGINAL` - Original
* `WAYBILL` - Waybill
* `SURRENDER` - Surrender
 */
export type HblTypeEnum = typeof HblTypeEnum[keyof typeof HblTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HblTypeEnum = {
  ORIGINAL: 'ORIGINAL',
  WAYBILL: 'WAYBILL',
  SURRENDER: 'SURRENDER',
} as const;
